import type { Dayjs } from 'dayjs'
import ru from 'dayjs/locale/ru'

interface ICustomLocale extends Omit<ILocale, 'monthsShort' | 'weekdaysShort'> {
  weekdaysShort: string[] | ((dayjsInstance: Dayjs, format: string) => string)
  monthsShort: string[] | ((dayjsInstance: Dayjs, format: string) => string)
}

const locale: ICustomLocale = {
  ...ru,
  name: 'ru',
  weekStart: 1,
  weekdaysShort: (dayjsInstance: Dayjs, format: string): string => {
    const extended = 'Вс_Пн_Вт_Ср_Чт_Пт_Сб'.split('_')
    const standard = 'вск_пнд_втр_срд_чтв_птн_сбт'.split('_')

    if (/^EXT_/.test(format)) {
      return extended[dayjsInstance.day()]
    } else {
      return standard[dayjsInstance.day()]
    }
  },
  monthsShort: (dayjsInstance: Dayjs, format: string): string => {
    const extended = 'Янв._Февр._Март_Апр._Май_Июнь_Июль_Авг._Сент._Окт._Нояб._Дек.'.split('_')
    const standard = 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_')

    if (/^EXT_/.test(format)) {
      return extended[dayjsInstance.month()]
    } else {
      return standard[dayjsInstance.month()]
    }
  }
}

export default locale
